<template>
  <v-card max-width="426" class="mx-auto pa-6 text-center">
    <h2 class="text-capitalize text-h5 text--secondary my-5 text-center">
      {{ $t("auth.resetPassword.title") }}
    </h2>
    <v-form
      @submit.prevent="onSubmit"
      ref="resetPassword"
      class="auth-reset-password"
    >
      <v-text-field
        :type="showNewPassword ? 'text' : 'password'"
        :placeholder="$t('auth.resetPassword.form.newPassword')"
        :rules="newPasswordRules"
        filled
        autofocus
        v-model="newPassword"
        class="theme-custom-input ma-auto"
      >
        <template v-slot:append>
          <div
            @click="showNewPassword = !showNewPassword"
            class="show-password-append"
          >
            <v-icon size="24" v-if="showNewPassword" class="cursor-pointer"
              >$eyeShow</v-icon
            >
            <v-icon size="24" class="cursor-pointer" v-else>$eyeHidden</v-icon>
          </div>
        </template>
      </v-text-field>

      <v-text-field
        :type="showNewPasswordRepetition ? 'text' : 'password'"
        :placeholder="$t('auth.resetPassword.form.newPasswordRepetition')"
        :rules="newPasswordRepetitionRules"
        filled
        v-model="newPasswordRepetition"
        validate-on-blur
        class="theme-custom-input ma-auto"
      >
        <template v-slot:append>
          <div
            @click="showNewPasswordRepetition = !showNewPasswordRepetition"
            class="show-password-append"
          >
            <v-icon
              size="24"
              v-if="showNewPasswordRepetition"
              class="cursor-pointer"
              >$eyeShow</v-icon
            >
            <v-icon size="24" class="cursor-pointer" v-else>$eyeHidden</v-icon>
          </div>
        </template>
      </v-text-field>

      <PasswordRegulation
        @conditionsResult="conditionsResult"
        :submission="submission"
        :password="newPassword"
      />

      <v-card-actions class="pa-0 auth-btn">
        <v-btn
          color="primary"
          :loading="loading"
          block
          class="py-7"
          type="submit"
          >{{ $t("auth.resetPassword.form.submit") }}</v-btn
        >
      </v-card-actions>

      <v-row justify="start" class="mt-4">
        <v-btn
          text
          color="primary"
          class="text-capitalize"
          :to="{ name: 'forgetPassword' }"
        >
          <v-icon
            size="20"
            :color="$vuetify.theme.themes.light.primary"
            :class="['me-2', { 'icon-rotation': $vuetify.rtl }]"
          >
            mdi-arrow-left-thin
          </v-icon>

          <span class="font-medium-14">
            {{ $t("auth.resetPassword.backButton") }}
          </span>
        </v-btn>
      </v-row>
    </v-form>
  </v-card>
</template>
<script>
import { authService } from "@/services";
import PasswordRegulation from "@/components/Auth/PasswordRegulation";
// import { mapGetters } from "vuex";

export default {
  name: "reset-password",
  components: { PasswordRegulation },
  props: [],
  data() {
    return {
      result: false,
      submission: false,
      loading: false,
      newPassword: "",
      newPasswordRepetition: "",
      otpToken: null,
      showNewPasswordRepetition: false,
      showNewPassword: false,
      newPasswordRules: [
        val => !!val || this.$t("auth.resetPassword.form.newPasswordNotEmpty")
      ],
      newPasswordRepetitionRules: [
        val =>
          !!val ||
          this.$t("auth.resetPassword.form.newPasswordRepetitionNotEmpty"),
        val =>
          val === this.newPassword || this.$t("auth.resetPassword.form.noMatch")
      ]
    };
  },
  computed: {
    // ...mapGetters({
    //   forgetPasswordData: "Auth1/GET_OTP_TOKEN_DATA",
    // }),
  },
  mounted() {
    if (localStorage.getItem("otpToken")) {
      this.otpToken = localStorage.getItem("otpToken");
    } else {
      this.$router.replace({ name: "forgetPassword" });
    }
  },
  methods: {
    conditionsResult(val) {
      this.result = val;
    },
    onSubmit() {
      if (!this.$refs.resetPassword.validate() && !this.result) {
        this.submission = true;
        return;
      }
      // localStorage.removeItem("otpToken");
      this.loading = true;
      authService
        .resetPassword(
          this.newPassword,
          this.newPasswordRepetition,
          this.otpToken
        )
        .then(() => {
          localStorage.removeItem("otpToken");
          this.$router.replace({ name: "loginForm" });
        })
        .catch(() => {
          // localStorage.setItem("otpToken", this.otpToken);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss">
@import "ResetPassword";
</style>
